export default function GloLayout({ id, style, className, children }: { id: string; style?: any; className: string; children: any }) {
    return (
        <section className={`editor-temp temp-${id} ${className}`} id={id} style={style}>
            {children}
        </section>
    );
}
